import { cn } from '@/lib/utils';

/**
 * O símbolo da marca: um "b" cujo laço se abre num nó âmbar — "do rastro à conexão".
 *
 * O `ux/icon.svg` traz fundo Obsidiana e traço Névoa fixos, o que é certo para um
 * favicon e errado dentro da aplicação: no modo claro ficaria ilegível. Aqui a
 * haste e o bojo usam `currentColor` (portanto `--text`), e o nó usa `--primary`.
 * Mesma geometria do arquivo original, tokens no lugar dos valores crus.
 *
 * Espaço de respiro (manual §8): a margem livre em volta equivale à altura do bojo.
 */
export function Marca({ tamanho = 28, className }: { tamanho?: number; className?: string }) {
  return (
    <svg
      viewBox="64 64 128 128"
      width={tamanho}
      height={tamanho}
      role="img"
      aria-label="bHunter"
      className={cn('text-text', className)}
    >
      <g transform="translate(64,64)">
        <rect x="34" y="22" width="13" height="84" rx="6.5" fill="currentColor" />
        <circle cx="67" cy="79" r="20.5" fill="none" stroke="currentColor" strokeWidth="13" />
        <line
          x1="81.5"
          y1="64.5"
          x2="100"
          y2="40"
          stroke="var(--primary)"
          strokeWidth="3.5"
          strokeLinecap="round"
        />
        <circle cx="100" cy="40" r="4.8" fill="var(--primary)" />
        <circle cx="81.5" cy="64.5" r="9" fill="var(--primary)" />
      </g>
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn('font-display font-bold tracking-tight text-text', className)}>
      bHunter
    </span>
  );
}

/**
 * Lockup. O manual manda usar o símbolo isolado abaixo de 120px de largura — daí
 * a variante `compacto`, para a sidebar estreita e o mobile.
 */
export function Lockup({ compacto = false, className }: { compacto?: boolean; className?: string }) {
  if (compacto) return <Marca tamanho={32} className={className} />;
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <Marca tamanho={30} />
      <Wordmark className="text-xl" />
    </div>
  );
}
